// Angular
import { Component, OnInit } from "@angular/core";
// Models
import { Tournament } from "./../../models/tournament";
// Services
import { AngularFireDatabase } from "angularfire2/database";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ApiService } from "./../../services/api";
import * as lodash from "lodash";
import { OAuthService } from "./../../services/o-auth";
import { Club } from "./../../models/club";
import { ActivatedRoute } from "@angular/router";
import { AngularFireAuth } from "angularfire2/auth";
import * as firebase from "firebase/app";
import * as moment from "moment";
import { FormsService } from "./../../services/forms";
import { ElasticService } from "app/services/elastic";

@Component({
  templateUrl: "./club.members.component.html",
})
export class ClubMembersComponent implements OnInit {
  public club: any;
  public form: FormGroup;
  public memberSize: number;
  public isEmailExist = false;
  public users: Array<any> = [];
  public query: string = "";
  public members: Array<any>;
  public user: any = {};
  private typingDelay: any;
  public imageLoader: boolean = false;

  constructor(
    private fireDatabase: AngularFireDatabase,
    public formsService: FormsService,
    private apiService: ApiService,
    private oAuthService: OAuthService,
    private route: ActivatedRoute,
    private fireAuth: AngularFireAuth,
    private elasticService: ElasticService
  ) {
    this.memberSize = 0;

    this.club = this.oAuthService.getClub();

    this.form = new FormGroup({
      fullName: new FormControl("", Validators.required),
      role: new FormControl(this.club.role),
      email: new FormControl("", Validators.email),
      username: new FormControl("", Validators.required),
      phone: new FormControl("", Validators.required),
      password: new FormControl("", [
        Validators.required,
        Validators.minLength(6),
      ]),
      confirm: new FormControl("", Validators.required),
    });

    this.form.controls["username"].valueChanges.subscribe((value) => {
      this.username(value);
    });

    this.form.controls["password"].valueChanges.subscribe(() => {
      this.confirm();
    });

    this.form.controls["confirm"].valueChanges.subscribe(() => {
      this.confirm();
    });
    this.form.controls["email"].valueChanges.subscribe((value) => {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(String(value).toLowerCase())) {
        this.checkEmail(value);
      }
    });
  }

  ngOnInit() {
    this.club = this.oAuthService.getClub();
    this.initData();
  }
  initData() {
    this.imageLoader = true;
    var memberId = this.club.cid ? this.club.cid : this.club.uid;
    this.members = [];
    console.log(memberId);
    this.apiService.object(`/club-members/${memberId}`).then((result) => {
      if (result) {
        this.members = [];
        lodash.forEach(result, async (item, key) => {
          if (item) {
            this.memberSize++;
            let user = await this.apiService.object(`/users/${key}`);
            let profile = await this.apiService.object(
              "user-profiles/" + key + "/" + memberId
            );
            user.status = profile.status ? profile.status : 1;
            user.isVerified = profile.isVerified ? profile.isVerified : true;
            user.role = profile.role ? profile.role : true;
            user.uid = key;
            this.members.push(user);
          }
        });
        this.imageLoader = false;
      } else {
        this.imageLoader = false;
      }
    });
  }

  removeMember(id, index) {
    if (confirm("Are you sure? You want to remove this Member")) {
      this.apiService.set(`/user-profiles/${id}/${this.club.cid}`, null);
      this.apiService.set(`/club-members/${this.club.cid}/${id}`, null);
      this.apiService.set(`/users/${id}/type`, 2);
      this.members.splice(index, 1);
      this.initData();
    }
  }
  username(value: string) {
    if (!value) {
      const errors = this.form.controls["username"].errors;
      if (errors) {
        delete errors.used;
        this.form.controls["username"].setErrors(errors);
      }
      return;
    }

    this.apiService
      .list("/index/users", {
        query: {
          orderByValue: true,
          equalTo: this.form.controls["username"].value.toLowerCase(),
        },
      })
      .then(
        (result) => {
          if (result.length) {
            this.form.controls["username"].setErrors({ used: true });
          } else {
            const errors = this.form.controls["username"].errors;
            if (errors) {
              delete errors.used;
              this.form.controls["username"].setErrors(errors);
            }
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }
  checkEmail(value) {
    this.fireAuth.auth.fetchProvidersForEmail(value).then((result) => {
      if (result.length) {
        this.isEmailExist = true;
        this.form.controls["password"].setErrors(null);
        this.form.controls["confirm"].setErrors(null);
        this.form.controls["username"].setErrors(null);
      } else {
        this.isEmailExist = false;
      }
    });
  }
  confirm() {
    const password = this.form.controls["password"].value;
    const confirm = this.form.controls["confirm"].value;

    if (password !== confirm) {
      this.form.controls["confirm"].setErrors({ confirm: true });
    } else {
      this.form.controls["confirm"].setErrors(null);
    }
  }

  public openModel() {
    $("#myModal").modal("show");
    this.form.reset({
      fullName: null,
      role: this.club.role,
      email: null,
      username: null,
      phone: null,
      password: null,
      confirm: null,
    });
    this.isEmailExist = false;
    // this.premiumService.canActivate().then(s => {
    //   if (s) {
    //   } else {
    //     alert("Buy a subscription plan");
    //   }
    // });
  }

  //moved to addMemberSubmit()
  // submit() {
  //   const email = this.form.value.email;
  //   if (!this.memberSize) {
  //     this.memberSize = 0;
  //   }
  //   this.memberSize++;
  //   let cid = this.club.cid ? this.club.cid : this.club.uid;
  //   var memberId = cid;
  //   if (this.memberSize < 10) {
  //     memberId += "-0" + this.memberSize;
  //   } else {
  //     memberId += "-" + this.memberSize;
  //   }
  //   console.log(memberId);

  //   const username = this.form.value.username;
  //   const phone = this.form.value.phone;
  //   const fullName = this.form.value.fullName;
  //   let key = this.club.cid;

  //   let req = {
  //     registerDate: moment().unix(),
  //     email: email,
  //     username: username,
  //     password: this.form.value.password,
  //     fullName: fullName,
  //     memberId: memberId,
  //     role: this.form.value.role,
  //     type: this.club.type,
  //     status: 1,
  //     cid: this.club.cid,
  //     phone: phone,
  //     isVerified: true,
  //     updatedAt: new Date().getTime() / 1000,
  //     isMember: true,
  //   };
  //   if (this.isEmailExist) {
  //     delete req.username;
  //     delete req.password;
  //   }
  //   this.apiService
  //     .set(`/server-process/create-user/${key}`, req)

  //     .then(() => {
  //       location.reload();

  //       return $("#myModal").modal("hide");
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       alert(error);
  //     });
  // }

  public activate(id) {
    if (confirm("Are you sure? You want to Activate the Member")) {
      this.apiService.set(`/user-profiles/${id}/${this.club.cid}/status`, 1);
      this.apiService.set(
        `/user-profiles/${id}/${this.club.cid}/isVerified`,
        true
      );

      this.initData();
    }
  }
  public deactivate(id) {
    if (confirm("Are you sure? You want to Deactivate the Member")) {
      this.apiService.set(`/user-profiles/${id}/${this.club.cid}/status`, 2);
      this.apiService.set(
        `/user-profiles/${id}/${this.club.cid}/isVerified`,
        false
      );

      this.initData();
    }
  }

  onFocus() {
    this.searchMention();
  }
  onBlur() {
    setTimeout(() => {
      this.users = [];
    }, 500);
  }

  searchMention() {
    const queryParams = {
      index: "users",
      type: "user",
      "body/query/bool/must/query_string/query": `${this.query}*`,
      "body/query/bool/must/query_string/fields": ["fullName^10", "username^2"],
    };

    this.elasticService
      .search(queryParams)
      .then((result) => {
        this.users = [];
        if (result && result["hits"]) {
          lodash.forEach(result["hits"], async (item) => {
            const user = lodash.assign({ $key: item["_id"] }, item["_source"]);

            if (user.$key) {
              user.key = user.$key;
            }
            let firebaseUser = await this.apiService.object(
              `users/${user.key}`
            );
            if (!firebaseUser.deactivated) {
              this.users.push(user);
            }
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  changeQuery() {
    clearTimeout(this.typingDelay);

    this.typingDelay = setTimeout(() => {
      this.searchMention();
    }, 400);
  }
  chooseUser(user) {
    this.user = user;
  }

  addMemberSubmit() {
    let clubId = this.club.cid;
    let req = {
      role: +this.user.role,
      type: this.club.type,
      status: 1,
      isVerified: true,
      updatedAt: new Date().getTime() / 1000,
    };
    let memberId = this.user.key;
    if (this.user.$key) {
      memberId = this.user.$key;
    }
    this.apiService
      .set(`/server-process/add-member/${clubId}/${memberId}`, req)
      .then(() => {
        this.closeModal();
        $("#myModal").modal("hide");
      })
      .then(() => location.reload())
      .catch((error) => {
        console.error(error);
        alert(error);
      });
  }

  closeModal() {
    this.user = {};
    this.query = "";
  }
}
